import { ReactNode } from 'react'

interface DocumentFooterProps {
  children: ReactNode
}

/**
 * Pie en flujo: cierra el cuerpo del documento. No confundir con el
 * `footerTemplate` de Chromium, que es el que se repite en cada página.
 */
export const DocumentFooter = ({ children }: DocumentFooterProps) => (
  <footer className='mt-auto break-inside-avoid border-t border-zinc-200 pt-3 text-[8pt] text-zinc-500'>
    {children}
  </footer>
)
